import axios from 'axios';
import { logout } from '../features/authSlice';
import { Dispatch } from '@reduxjs/toolkit';

export const handleAxiosError = (error: unknown, dispatch: Dispatch) => {
  if (axios.isAxiosError(error)) {
    if (error.response?.status === 401) {
      console.log('Unauthorized - Logging out');
      dispatch(logout()); // Dispatch the logout action
    } else {
      console.error('Error response:', error.response?.data);
    }
  } else {
    console.error('Unexpected error:', error);
  }
};

export function formatDateString(input: any) {
  if (!input) return '';
  const [month, day, year] = input.split('.').map(Number);
  const date = new Date(year, month - 1, day); // الشهر يبدأ من 0

  return new Intl.DateTimeFormat('en-US', {
    month: 'long',
    day: 'numeric',
    year: 'numeric',
  }).format(date);
}

export function formatDate(dateStr: string) {
  const date = new Date(dateStr);
  const yyyy = date.getFullYear();
  const mm = String(date.getMonth() + 1).padStart(2, '0');
  const dd = String(date.getDate()).padStart(2, '0');
  return `${yyyy}/${mm}/${dd}`;
}
